import { FC, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
// import { Link, useNavigate } from 'react-router-dom';
import { BusinessSignUpFormValidationSchema } from '@features/SignUp/signUpFormValidation.ts';
// import { businessSignUp } from '@api/auth/apiService.ts';
import toast from 'react-hot-toast';
import { Toast } from '@components/Toast/ui/Toast.tsx';
import { FormInput } from '@components/FormInput/ui/FormInput';
import { Button, TermsPrivacyModal } from '@components/index';
import InputCheckbox from '@components/InputCheckbox/ui/InputCheckbox';
import { checkPasswordComplexity } from '@utils/utils';
import { BusinessSignUpFormDefaultValues } from '@providers/SignUpFormProvider/model/types';
import { Stack, Theme, Typography, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import styles from './BusinessSignUpForm.module.scss';

// import AddPaymentMethodModal from '@features/AddPaymentMethodModal/ui/AddPaymentMethodModal';
// import { Elements } from '@stripe/react-stripe-js';
// import { loadStripe } from '@stripe/stripe-js';
// import { saveStripeInfoDuringSignup } from '@api/user/apiService';
// import { CaseSubscriptionApi } from '@api/case-subscription/caseSubscription';

interface IBusinessSignUpFormProps {}

// const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY);

interface BusinessSignUpForm {
  firstName: string;
  lastName: string;
  companyName: string;
  email: string;
  phone: string;
  password: string;
  confirmPassword: string;
  acceptTerms: boolean;
}

const BusinessSignUpForm: FC<IBusinessSignUpFormProps> = () => {
  // const navigate = useNavigate();
  const [loading] = useState<boolean>(false);
  const [openTermsModal, setOpenTermsModal] = useState<boolean>(false);
  // const [openPaymentModal, setOpenPaymentModal] = useState<boolean>(false);
  // const [pendingSignUpData, setPendingSignUpData] = useState<BusinessSignUpRequestData | null>(null);
  const downMD = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const formMethods = useForm<BusinessSignUpForm>({
    mode: 'onChange',
    defaultValues: {
      firstName: BusinessSignUpFormDefaultValues.firstName,
      lastName: BusinessSignUpFormDefaultValues.lastName,
      companyName: BusinessSignUpFormDefaultValues.companyName,
      password: BusinessSignUpFormDefaultValues.password,
      confirmPassword: BusinessSignUpFormDefaultValues.confirmPassword,
      email: BusinessSignUpFormDefaultValues.email,
      phone: '',
      acceptTerms: BusinessSignUpFormDefaultValues.acceptTerms,
    },
    resolver: yupResolver(BusinessSignUpFormValidationSchema),
  });

  const password = formMethods.watch('password');

  const handleAcceptTerms = () => {
    formMethods.setValue('acceptTerms', true, {
      shouldValidate: true,
      shouldDirty: true,
    });
    setOpenTermsModal(false);
  };

  const handleCloseTerms = () => {
    setOpenTermsModal(false);
    formMethods.setValue('acceptTerms', false, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const handleTermsCheckboxChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    const { checked } = event.target;
    if (checked) {
      // Require explicit acceptance via modal
      formMethods.setValue('acceptTerms', false, {
        shouldValidate: true,
        shouldDirty: true,
      });
      setOpenTermsModal(true);
    } else {
      formMethods.setValue('acceptTerms', false, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  const onSubmit = (_data: BusinessSignUpForm) => {
    toast(({ id }) => (
      <Toast
        id={id}
        type="error"
        title="Business sign-up unavailable"
        text="Business sign-up is temporarily disabled. Please contact support or try again later."
      />
    ));

    // const signUpData: BusinessSignUpRequestData = {
    //   firstName: data.firstName,
    //   lastName: data.lastName,
    //   companyName: data.companyName,
    //   email: data.email,
    //   phone: data.phone,
    //   password: data.password,
    // };

    // setPendingSignUpData(signUpData);
    // setOpenPaymentModal(true);
  };

  // const handlePaymentCancel = () => {
  //   setOpenPaymentModal(false);
  // };

  // const handlePaymentConfirm = (_paymentMethodId: string) => {
  //   setOpenPaymentModal(false);
  //   setPendingSignUpData(null);
  //   setLoading(false);

  //   toast(({ id }) => (
  //     <Toast
  //       id={id}
  //       type="error"
  //       title="Business sign-up unavailable"
  //       text={'Business sign-up processing is currently disabled. Please contact support or try again later.'}
  //     />
  //   ));

  //   // if (!pendingSignUpData) return;
  //   // setLoading(true);
  //   // businessSignUp(
  //   //   pendingSignUpData,
  //   //   (_response) => {
  //   //     setTimeout(() => {
  //   //       saveStripeInfoDuringSignup(
  //   //         pendingSignUpData.email,
  //   //         paymentMethodId,
  //   //         async () => {
  //   //           try {
  //   //             await CaseSubscriptionApi.createTrialSubscription(pendingSignUpData.email);
  //   //           } catch (e) {
  //   //             console.error('Failed to create trial subscription at signup:', e);
  //   //           }
  //   //           toast(({ id }) => (
  //   //             <Toast
  //   //               id={id}
  //   //               type="success"
  //   //               title="Success"
  //   //               text={'Your business account has been created with a free trial. Please log in to start using Zlayt AI.'}
  //   //             />
  //   //           ), { duration: 10000 });
  //   //           setLoading(false);
  //   //           navigate('/sign-in');
  //   //         },
  //   //         (error) => {
  //   //           console.error('Error saving payment method during business signup:', error);
  //   //           toast(({ id }) => (
  //   //             <Toast
  //   //               id={id}
  //   //               type="success"
  //   //               title="Success"
  //   //               text={'Your business account has been created. You can add a payment method in Billing later.'}
  //   //             />
  //   //           ), { duration: 10000 });
  //   //           setLoading(false);
  //   //           navigate('/sign-in');
  //   //         },
  //   //         () => {}
  //   //       );
  //   //     }, 1000);
  //   //   },
  //   //   (error: any) => {
  //   //     toast(({ id }) => (
  //   //       <Toast
  //   //         id={id}
  //   //         type="error"
  //   //         title="Error"
  //   //         text={error?.response?.data?.message}
  //   //       />
  //   //     ));
  //   //     setLoading(false);
  //   //   }
  //   // );
  // };

  useEffect(() => {
    if (!password) return;
    formMethods.trigger('confirmPassword');
  }, [password]);

  return (
    <>
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={12}>
          <Grid
            container
            direction={{ xs: 'column-reverse', md: 'row' }}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item>
              <Stack
                alignItems="center"
                justifyContent="center"
                spacing={1}
                paddingX={3}
              >
                <Typography
                  color="gray.main"
                  gutterBottom
                  variant={downMD ? 'h3' : 'h2'}
                  textAlign="center"
                >
                  Create a business account
                </Typography>
                <Typography
                  color="gray"
                  gutterBottom
                  fontSize={14}
                  variant="subtitle2"
                  textAlign="center"
                >
                  Sign up to ZlaytAI as a business user.
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <form onSubmit={formMethods.handleSubmit(onSubmit)}>
            <Grid container spacing={2}>
              <Grid item container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormInput
                    bordered
                    type="input"
                    labelText="First name"
                    required
                    placeholder="Enter first name"
                    errorText={
                      formMethods.formState.errors?.firstName &&
                      formMethods.formState.errors?.firstName.message
                    }
                    autoComplete
                    {...formMethods.register('firstName')}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormInput
                    bordered
                    type="input"
                    labelText="Last name"
                    required
                    placeholder="Enter last name"
                    errorText={
                      formMethods.formState.errors?.lastName &&
                      formMethods.formState.errors?.lastName.message
                    }
                    autoComplete
                    {...formMethods.register('lastName')}
                  />
                </Grid>
              </Grid>
              <Grid item container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormInput
                    bordered
                    type="input"
                    labelText="Company name"
                    required
                    placeholder="Enter company name"
                    errorText={
                      formMethods.formState.errors?.companyName &&
                      formMethods.formState.errors?.companyName.message
                    }
                    autoComplete
                    {...formMethods.register('companyName')}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormInput
                    bordered
                    type="input"
                    labelText="Email"
                    required
                    placeholder="name@company.com"
                    errorText={
                      formMethods.formState.errors?.email &&
                      formMethods.formState.errors?.email.message
                    }
                    {...formMethods.register('email')}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <FormInput
                  bordered
                  type="input"
                  labelText="Phone number"
                  required
                  placeholder=" +1 (555) 000-0000"
                  inputMode="tel"
                  pattern="[+0-9 ()-]+"
                  errorText={formMethods.formState.errors.phone?.message}
                  {...formMethods.register('phone')}
                />
              </Grid>
              <Grid item xs={12}>
                <div className={styles.passwordComplexityWrapper}>
                  <FormInput
                    bordered
                    type="password"
                    labelText="Password"
                    required
                    placeholder="Create password"
                    errorText={
                      formMethods.formState.errors?.password &&
                      formMethods.formState.errors?.password.message
                    }
                    {...formMethods.register('password')}
                  />
                  <div
                    className={[
                      styles.complexity,
                      styles[`level-${checkPasswordComplexity(password)}`],
                    ].join(' ')}
                  >
                    <span />
                    <span />
                    <span />
                    <span />
                  </div>
                  <p className={styles.description}>
                    Use 8+ characters, with a mix of letters, numbers & symbols.
                  </p>
                </div>
              </Grid>
              <Grid item xs={12}>
                <FormInput
                  bordered
                  type="password"
                  labelText="Confirm password"
                  required
                  placeholder="Confirm password"
                  errorText={
                    formMethods.formState.errors?.confirmPassword &&
                    formMethods.formState.errors?.confirmPassword.message
                  }
                  {...formMethods.register('confirmPassword')}
                />
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" alignItems="center">
                  <InputCheckbox
                    error={!!formMethods.formState.errors.acceptTerms?.message}
                    {...formMethods.register('acceptTerms')}
                    onChange={handleTermsCheckboxChange}
                  />
                  <p>I Accept the Terms of Service and Privacy Policy</p>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  className={styles.signUpBtn}
                  disabled={!formMethods.formState.isValid}
                  variant="active"
                  isLoading={loading}
                >
                  Continue to payment
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Grid item container direction="column" alignItems="center" xs={12}>
            <Stack
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="subtitle1" sx={{ textDecoration: 'none' }}>
                Already have an account?
              </Typography>
              <Link to="/sign-in">
                <Button variant="underline">Login</Button>
              </Link>
            </Stack>
          </Grid>
        </Grid>
      </Grid>

      <TermsPrivacyModal
        open={openTermsModal}
        onAccept={handleAcceptTerms}
        onClose={handleCloseTerms}
        termsDocxUrl="/legal/Terms of Use - Zlayt.AI.docx"
        privacyDocxUrl="/legal/Zlate Privacy Policy.docx"
      />

      {/*
      Payment Method Modal temporarily disabled for business sign-up
      <Elements stripe={stripePromise}>
        {openPaymentModal && (
          <AddPaymentMethodModal
            showModal={openPaymentModal}
            onCancel={handlePaymentCancel}
            onConfirm={(paymentMethodId: string) => handlePaymentConfirm(paymentMethodId)}
            saveDirectly={false}
          />
        )}
      </Elements>
    */}
    </>
  );
};

export default BusinessSignUpForm;
